<template>
  <div
    class="footer-area-wrapper gray-gradient"
    style="background: rgb(246,245,249)"
  >
    <div class="footer-area" style="padding-top:30px;">
      <div class="container">
        <div class="row footer-widget-wrapper">
          <div class="col-lg-5 col-md-6 footer-widget">
            <div class="footer-widget__logo mb-10">
              <router-link to="/">
                <img
                  src="/logo-2.png"
                  alt="logo"
                  style="height: 2.3rem; width: auto; border-radius:6px;"
                />
                <span
                  style="color: #2e3280;
                  font-family: Rubik, Helvetica, Arial, sans-serif;
                  font-weight: 500;
                  font-size:1.1rem;line-height:2rem;"
                  class="ml-2"
                  >Sandrasoft</span
                >
              </router-link>
            </div>
            <ul class="footer-widget__list">
              <h6 class="footer-widget__title" style="margin-top:25px;">
                Office
              </h6>
              <li class="mt-2">
                <router-link to="/" class="hover-style-link"
                  >Sonatus Building, 15 Le Thanh Ton, Ben Nghe ward, District 1,
                  Ho Chi Minh, Vietnam</router-link
                >
              </li>
              <h6 class="footer-widget__title" style="margin-top:10px;">
                Time
              </h6>
              <li class="mt-2">8:30am - 6:30pm, Mon - Fri</li>
              <li class="mt-3">&copy; 2022 by <b>Sandrasoft</b></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-widget"></div>
          <div class="col-lg-4 col-md-6 footer-widget" style="margin-top:60px;">
            <h6 class="footer-widget__title mb-20">Contact Information</h6>
            <ul class="footer-widget__list" style="margin-top:-15px;">
              <li>
                <span
                  style="
                  font-family: Rubik, Helvetica, Arial, sans-serif;
                  font-weight: 400;
                  font-size:1rem;line-height:1rem;margin-top:-15px;"
                  >Nicheal Pham
                </span>
                <a
                  href="https://www.linkedin.com/in/nichealpham/"
                  target="_blank"
                  class="social-link mr-4 ml-3"
                  style="font-size:1.5rem;margin-bottom:-10px;"
                  ><i class="fab fa-linkedin social-link-icon"></i
                ></a>
                <a
                  href="https://github.com/nichealpham/"
                  target="_blank"
                  class="social-link"
                  style="font-size:1.5rem;margin-bottom:-10px;"
                  ><i class="fab fa-github social-link-icon"></i
                ></a>
              </li>
              <li>Technical Solution Architect</li>
              <li>Company code: 0316961176</li>
              <li>
                <a href="mailto:nichealpham@gmail.com" class="hover-style-link"
                  >Email: support@sandrasoft.app</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterMain",
  props: ["FooterStyle"],
  data() {
    return {
      image: require("@/assets/SandraSoft/Logo/Logo_Gradient.png"),
    };
  },
};
</script>
